import { Instagram, Phone, MapPin, Clock } from "lucide-react";
import {
  ADDRESS,
  INSTAGRAM_URL,
  PHONE_LANDLINE_DISPLAY,
  PHONE_LANDLINE_TEL,
  PHONE_MOBILE_DISPLAY,
  PHONE_MOBILE_TEL,
} from "../data/site";

const QUICK_LINKS = [
  { id: "home", label: "Home" },
  { id: "about", label: "About Us" },
  { id: "services", label: "Services" },
  { id: "contact", label: "Location & Contact" },
];

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#2B2F26]">
    <div className="gold-hairline h-px w-full" />
    <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 sm:px-8 md:grid-cols-2 lg:grid-cols-3">
      <div>
        <div className="flex items-center gap-3">
          <img
            src="/logo.png"
            alt="Her Styles Ladies Salon logo"
            data-testid="footer-logo-image"
            className="h-16 w-16 object-contain"
          />
          <div>
            <p className="font-brand text-xl tracking-[0.2em] text-[#F2EFE6]">HER STYLES</p>
            <p className="font-body text-[10px] font-medium uppercase tracking-[0.42em] text-[#C9A24B]">
              Ladies Salon
            </p>
          </div>
        </div>
        <p className="mt-5 max-w-xs font-body text-sm leading-relaxed text-[#F2EFE6]/70">
          A bespoke beauty and wellness sanctuary for women, in the heart of Al Qusais,
          Dubai.
        </p>
        <a
          href="#book"
          data-testid="footer-book-now-button"
          className="btn-shimmer mt-6 inline-block rounded-full bg-[#C9A24B] px-7 py-3 font-body text-xs font-semibold uppercase tracking-[0.2em] text-[#2B2F26] transition-colors duration-300 hover:bg-[#D4AF37]"
        >
          Book Now
        </a>
      </div>

      <div>
        <h3 className="font-body text-xs font-semibold uppercase tracking-[0.3em] text-[#C9A24B]">
          Explore
        </h3>
        <ul className="mt-5 space-y-3">
          {QUICK_LINKS.map((link) => (
            <li key={link.id}>
              <a
                href={`#${link.id}`}
                data-testid={`footer-link-${link.id}`}
                className="font-body text-sm text-[#F2EFE6]/75 transition-colors duration-300 hover:text-[#C9A24B]"
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <h3 className="font-body text-xs font-semibold uppercase tracking-[0.3em] text-[#C9A24B]">
          Get in Touch
        </h3>
        <div className="mt-5 space-y-3">
          <a
            href={PHONE_MOBILE_TEL}
            data-testid="footer-phone-mobile-link"
            className="flex items-center gap-3 font-body text-sm text-[#F2EFE6]/75 transition-colors duration-300 hover:text-[#C9A24B]"
          >
            <Phone className="h-4 w-4 text-[#C9A24B]" />
            {PHONE_MOBILE_DISPLAY}
          </a>
          <a
            href={PHONE_LANDLINE_TEL}
            data-testid="footer-phone-landline-link"
            className="flex items-center gap-3 font-body text-sm text-[#F2EFE6]/75 transition-colors duration-300 hover:text-[#C9A24B]"
          >
            <Phone className="h-4 w-4 text-[#C9A24B]" />
            {PHONE_LANDLINE_DISPLAY}
          </a>
          <p className="flex items-start gap-3 font-body text-sm leading-relaxed text-[#F2EFE6]/75">
            <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-[#C9A24B]" />
            {ADDRESS}
          </p>
          <p
            data-testid="footer-opening-hours"
            className="flex items-start gap-3 font-body text-sm leading-relaxed text-[#F2EFE6]/75"
          >
            <Clock className="mt-0.5 h-4 w-4 shrink-0 text-[#C9A24B]" />
            Open Daily: 10:00 AM – 9:00 PM
          </p>
        </div>
        <a
          href={INSTAGRAM_URL}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Follow Her Styles on Instagram"
          data-testid="footer-social-instagram"
          className="group mt-6 inline-flex items-center gap-3 font-body text-sm text-[#F2EFE6]/75 transition-colors duration-300 hover:text-[#C9A24B]"
        >
          <span className="flex h-10 w-10 items-center justify-center rounded-full border border-[rgba(201,162,75,0.4)] text-[#C9A24B] transition-colors duration-300 group-hover:bg-[#C9A24B] group-hover:text-[#2B2F26]">
            <Instagram className="h-4 w-4" />
          </span>
          @herstyles_salon_26
        </a>
      </div>
    </div>

    <div className="border-t border-[rgba(201,162,75,0.15)]">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-5 py-6 text-center sm:flex-row sm:px-8 sm:text-left">
        <p className="font-body text-xs tracking-wider text-[#F2EFE6]/60">
          &copy; 2026 Her Styles Ladies Salon. All rights reserved.
        </p>
        <p className="font-body text-xs tracking-wider text-[#F2EFE6]/60">
          Powered by <span className="text-[#C9A24B]">Emergent</span>
        </p>
      </div>
    </div>
  </footer>
);
